var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('nav',[_c('ul',{staticClass:"cd-primary-nav"},[_c('li',[_c('router-link',{staticClass:"animated_link",attrs:{"to":"/"}},[_vm._v("Home")])],1)])]),_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }